import type { UserCompetency } from 'shared-types';

export type MergedCompetency = Pick<
  UserCompetency,
  | 'availableLevels'
  | 'description'
  | 'descriptionLocales'
  | 'expirationDate'
  | 'id'
  | 'name'
  | 'nameLocales'
> & {
  endorsements?: UserCompetency['endorsements'];
  grantors?: UserCompetency['grantors'];
  level?: UserCompetency['level'];
  highestLevel?: UserCompetency['level'];
  levels?: (UserCompetency['level'] & {
    endorsements: UserCompetency['endorsements'];
    grantors: UserCompetency['grantors'];
  })[];
};

const getMergedCompetencies = (competencies: UserCompetency[]) => {
  const mergedCompetencies: MergedCompetency[] = [];
  competencies?.forEach((competency) => {
    const existingCompetency = mergedCompetencies.find(
      (mergedCompetency) => mergedCompetency.id === competency.id
    );

    if (competency.availableLevels?.length) {
      const { endorsements, grantors, level, ...properties } = competency;

      let mergedCompetency: MergedCompetency;
      if (!existingCompetency) {
        mergedCompetency = {
          ...properties,
          levels: competency.availableLevels.map((availableLevel) => ({
            ...availableLevel,
            endorsements: [],
            grantors: []
          }))
        };
      } else mergedCompetency = existingCompetency;

      if (level?.id) {
        if (
          !mergedCompetency.highestLevel?.id ||
          level.level > mergedCompetency.highestLevel.level
        ) {
          mergedCompetency.highestLevel = level;
          mergedCompetency.expirationDate = competency.expirationDate;
        }

        const existingLevel = mergedCompetency.levels?.find(
          (existingLevel) => existingLevel.id === level.id
        );
        if (existingLevel) {
          existingLevel.endorsements = endorsements;
          existingLevel.grantors = grantors;
        }
      }

      if (!existingCompetency) mergedCompetencies.push(mergedCompetency);
    } else mergedCompetencies.push(competency);
  });

  return mergedCompetencies;
};

export default getMergedCompetencies;
